// The adult Dugzi, library v6 (brain/brand/assets/mascot-current-v6). Art: ./mascot-art.ts.
// Legacy pose keys are compatibility aliases; use semantic scenarios for new product work.
import { SCENE_ART } from './mascot-art';

export type SceneArt = (typeof SCENE_ART)[keyof typeof SCENE_ART];

export const POSES = {
  'greeting': SCENE_ART.greeting,
  'planner': SCENE_ART.planner,
  'mail': SCENE_ART.mail,
  'reading': SCENE_ART.planner,
  'playing': SCENE_ART.tasks,
  'napping': SCENE_ART.resting,
  'head': SCENE_ART.greeting,
  'waving': SCENE_ART.hello,
  'letter': SCENE_ART.mail,
  'celebrating': SCENE_ART.tasks,
  'parcel': SCENE_ART.filing,
  'attentive': SCENE_ART.greeting,
  'place-saved': SCENE_ART.tasks,
  'writing': SCENE_ART.creating,
  'sorting': SCENE_ART.people,
  'finding': SCENE_ART.filing,
  'filing': SCENE_ART.filing,
  'threshold': SCENE_ART.people,
  'building': SCENE_ART.creating,
  'creating': SCENE_ART.creating,
  'tasks': SCENE_ART.tasks,
  'people': SCENE_ART.people,
  'publishing': SCENE_ART.publishing,
  'moving': SCENE_ART.moving,
  'hello': SCENE_ART.hello,
  'arrive': SCENE_ART.arrive,
  'resting': SCENE_ART.resting,
} as const;
export type MascotPose = keyof typeof POSES;

/** Scenes follow confirmed product state. A null scene deliberately gives the task space. */
export const MASCOT_SCENARIOS = {
  "site.hero": "greeting",
  "site.invite": "letter",
  "site.join": "waving",
  "account.arrive": "arrive",
  "account.address": null,
  "account.signin": null,
  "account.passkey.intro": null,
  "account.welcome.ready": "letter",
  "account.invites": "letter",
  "mail.pick": null, // the idle reader shows on every visit: repeated work gets no character (brand ch. 11)
  "mail.start": "letter",
  "mail.quiet": null,
  "mail.fyi.empty": null,
  "mail.digest.empty": null,
  "mail.requests.empty": null,
  "mail.starred.empty": null,
  "mail.sent.empty": null,
  "mail.drafts.empty": null,
  "mail.archive.empty": null,
  "mail.search.empty": null,
  "code.first-repository": "building",
  "tasks.first-list": "tasks",
  "contacts.first-circle": "people",
  "chat.first-space": "people",
  "docs.first-document": "creating",
  "sensitive": null,
  "loading": null,
  "failure": null,
  "mail.junk.empty": null,
  "mail.trash.empty": null,
  "code.checks.empty": null,
  "code.pulls.empty": null,
  "docs.trash.empty": null,
  "docs.filtered.empty": null,
  "drive.first-files": "filing",
  "drive.folder.empty": null,
  "drive.trash.empty": null,
  "drive.starred.empty": null,
  "drive.shared.empty": null,
  "drive.recent.empty": null,
  "sheets.first-spreadsheet": "creating",
  "slides.first-presentation": "creating",
  "search.home": null
} as const;
export type MascotScenario = keyof typeof MASCOT_SCENARIOS;
export function mascotPose(scene: MascotScenario): MascotPose | null { return MASCOT_SCENARIOS[scene]; }
